export const Prioritys = [
    { name: 'Undefined', icon: 'fas fa-times-circle mx-2' },
    { name: 'Low', icon: 'far fa-window-minimize mx-2' },
    { name: 'Medium', icon: 'fas fa-equals mx-2' },
    { name: 'High', icon: 'fas fa-bars mx-2' },
    { name: 'Critical', icon: 'fas fa-align-justify mx-2' }
]

export const Types = [
    { name: 'Undefined', icon: 'fas fa-times-circle mx-2' },
    { name: 'Info', icon: 'fas fa-info-circle mx-2' },
    { name: 'Consult', icon: 'fas fa-question-circle mx-2' },
    { name: 'Problem', icon: 'fas fa-exclamation-circle mx-2' },
    { name: 'Add-ons', icon: 'fas fa-plus-circle mx-2' }
]

export const CurrentStatus = [
    { name: 'Draft', icon: 'fas fa-pen mx-2' },
    { name: 'Informed', icon: 'fas fa-pen mx-2' },
    { name: 'More Info', icon: 'fas fa-history mx-2' },
    { name: 'In Progress', icon: 'fas fa-clock mx-2' },
    { name: 'Accepted', icon: 'fas fa-check mx-2' },
    { name: 'Assigned', icon: 'fas fa-user-check mx-2' },
    { name: 'Resolved', icon: 'fas fa-tasks mx-2' },
    { name: 'DEV Resolved', icon: 'fas fa-tasks mx-2' },
    { name: 'Closed', icon: 'fas fa-check-circle mx-2' },
    { name: 'Rejected', icon: 'fas fa-times-circle mx-2' },
    { name: 'Pending', icon: 'fas fa-stopwatch mx-2' }
]

export const iconAttachFile = [
    { type: 'xlsx', icon: 'fas fa-file-excel fa-lg excel-color' },
    { type: 'pdf', icon: 'fas fa-file-pdf fa-lg pdf-color' },
    { type: 'jpg', icon: 'fas fa-file-image fa-lg jpg-color' },
    { type: 'png', icon: 'fas fa-file-image fa-lg png-color' },
    { type: 'docx', icon: 'fas fa-file-word fa-lg word-color' },
    { type: 'pptx', icon: 'fas fa-file-powerpoint fa-lg powerpoint-color' },
    { type: 'mp4', icon: 'fas fa-file-video fa-lg' }
]

export const Sources = [
    { icon: 'fas fa-globe-americas primary-color', name: 'Website' },
    { icon: 'fab fa-line line-color', name: 'Line' },
    { icon: 'fas fa-envelope gmail-color', name: 'Email' },
    { icon: 'fas fa-phone call-color', name: 'Telephone' },
    { icon: 'fas fa-user-friends on-site-color', name: 'Onsite' },
    { icon: 'fab fa-facebook-square fb-color', name: 'Facebook' },
    { icon: 'fas fa-comments conference-color', name: 'Conference' },
    { icon: 'fas fa-ellipsis-v other-color', name: 'Other' }
]
